"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _logger = _interopRequireDefault(require("./logger"));
var defaultOptions = {
  debug: false,
  delay: 500,
  onError: function onError() {}
};

/**
 * Client side tasks queue
 * @class
 * @example
 * ```ts
 * const queue = new Queue()
 * queue.push(() => {})
 * ```
 */
var Queue = /*#__PURE__*/function () {
  /**
   * @param options Options
   */
  function Queue(options) {
    var _this = this;
    this.running = false;
    this.execute = /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var task;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            task = _this.tasks.shift();
            if (task) {
              _context.next = 4;
              break;
            }
            _this.log("Queue is empty. Waiting for a new task");
            return _context.abrupt("return");
          case 4:
            _context.prev = 4;
            _this.log("Task found. Run executor", task);
            _context.next = 8;
            return task();
          case 8:
            _context.next = 14;
            break;
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](4);
            _this.log("Run executor failed", _context.t0);
            if (_this.options.onError) {
              _this.options.onError(_context.t0, task);
            }
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[4, 10]]);
    }));
    this.options = (0, _extends2.default)({}, defaultOptions, options);
    this.tasks = [];
    this.logger = new _logger.default("queue");
    this.log("Starting process tasks after " + this.options.delay + "ms");
    this.run();
  }

  /**
   * Add task in queue
   * @param task Task function
   */
  var _proto = Queue.prototype;
  _proto.push = function push(task) {
    this.pushTask(task);
  };
  _proto.log = function log(message, meta) {
    if (!this.options.debug) return;
    this.logger.debug(message, meta);
  };
  _proto.pushTask = function pushTask(task) {
    this.tasks.push(task);
    this.log("Task registered. Waiting for CPU is idle", task);
    if (this.running) {
      this.requestPopInIdle();
    }
  };
  _proto.requestPopInIdle = function requestPopInIdle() {
    (window.requestIdleCallback || window.setTimeout)(this.execute);
  };
  _proto.run = function run() {
    var _this2 = this;
    if (typeof window !== "undefined") {
      var performance = window.performance.getEntriesByType("navigation")[0];
      if (performance && performance.loadEventEnd > 0) {
        this.runTasksExecutor();
      } else {
        window.addEventListener("load", function () {
          return setTimeout(_this2.runTasksExecutor.bind(_this2), _this2.options.delay);
        });
      }
    }
  };
  _proto.runTasksExecutor = function runTasksExecutor() {
    var _this3 = this;
    this.tasks.forEach(function () {
      return _this3.requestPopInIdle();
    });
    this.running = true;
  };
  return Queue;
}();
var _default = Queue;
exports.default = _default;